<template>
    <div class="bottom-view"></div>
</template>
<style lang="scss">
@import '../assets/css/bottom.scss';
</style>